export default __webpack_public_path__ + "static/media/mainImage.56832dfe.png";